export default "__VITE_ASSET__673362b7__"